import UserList from '@/components/User/list'
import HomeTechs from '@/components/User/HomeTechs'
import TechDetail from '@/components/User/TechDetail'
import UserListArchive from '@/components/User/list_archive'
import UserNew from '@/components/User/new'
import UserEdit from '@/components/User/edit'
import UserEditArchive from '@/components/User/edit_archive'
import UserShow from '@/components/User/show'
import UserShowArchive from '@/components/User/show_archive'
import UserDelete from '@/components/User/delete'
import UserDeleteArchive from '@/components/User/delete_archive'
import UserAuthorization from '@/components/User/authorization'
import UserImport from '@/components/User/import'
import AdminUserList from "./AdminUserList";
import AdminUserForm from "./AdminUserForm";
import AdminUserDetail from "./AdminUserDetail";
// import ChangeAddress from '@/components/User/ChangeAddress'
import UserAddIndispo from '@/components/User/UserAddIndispo'

let UserRouter = [
  {
    path: '/admin/user',
    name: 'AdminUserList',
    component: AdminUserList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/admin/user/new',
    name: 'AdminUserNew',
    component: AdminUserForm,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/admin/user/:id/edit',
    name: 'AdminUserEdit',
    component: AdminUserForm,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/admin/user/:id',
    name: 'AdminUserDetail',
    component: AdminUserDetail,
    meta: {
      requiresAuth: true
    }
  },
    {
  path: '/user',
  name: 'UserList',
  component: UserList
}, {
  path: '/user/techs',
  name: 'HomeTechs',
  component: HomeTechs
}, {
  path: '/user/archive',
  name: 'UserListArchive',
  component: UserListArchive
}, {
  path: '/user/new',
  name: 'UserNew',
  component: UserNew
}, {
  path: '/user/import',
  name: 'UserImport',
  component: UserImport
}, {
  path: '/user/:id/edit',
  name: 'UserEdit',
  component: UserEdit
}, {
  path: '/user/archive/:id/edit',
  name: 'UserEditArchive',
  component: UserEditArchive
}, {
  path: '/user/:id',
  name: 'UserShow',
  component: UserShow
}, {
  path: '/user/archive/:id',
  name: 'UserShowArchive',
  component: UserShowArchive
}, {
  path: '/user/:id/delete',
  name: 'UserDelete',
  component: UserDelete
}, {
  path: '/user/archive/:id/delete',
  name: 'UserDeleteArchive',
  component: UserDeleteArchive
}, {
  path: '/user/:id/authorization',
  name: 'UserAuthorization',
  component: UserAuthorization
}, {
  path: '/user/tech/detail/:id',
  name: 'TechDetail',
  component: TechDetail,
},/* {
  path: '/user/edit-address',
  name: 'ChangeAddress',
  component: ChangeAddress,
},*/ {
  path: '/user/add-indispo',
  name: 'UserAddIndispo',
  component: UserAddIndispo,
}]

export default UserRouter



// WEBPACK FOOTER //
// ./src/components/User/router.js